import React, { lazy } from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/9HSXTHePt54p7sgNwsQ5pQ/LOGO_DEFINIDO_DE_SOLUCIONESYA.SHOP.png';
export function StatsStrip() {
  const stats = [{
    number: '8',
    label: 'Tomos de acción'
  }, {
    number: '4',
    label: 'Bonos incluidos'
  }, {
    number: '+300',
    label: 'Páginas de contenido'
  }, {
    number: '15',
    label: 'Cartas modelo'
  }, {
    number: '40',
    label: 'Términos legales'
  }, {
    number: "45'",
    label: 'Para actuar'
  }];
  return <section className="py-10 md:py-[50px] px-5 bg-blue text-white text-center" data-id="element-238">
      <div className="max-w-[860px] mx-auto" data-id="element-239">
        <div className="text-[11px] font-extrabold tracking-[0.14em] uppercase text-gold mb-3" data-id="element-240">
          El sistema completo
        </div>

        {/* Solucionesya logo */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-241">
          <img src={LOGO_URL} alt="solucionesya.shop" width="320" height="160" loading="lazy" decoding="async" className="h-12 md:h-16 w-auto object-contain bg-white rounded-lg px-4 py-2 shadow-md" data-id="element-242" />
        </div>

        <h2 className="font-display text-[clamp(24px,5vw,44px)] text-white leading-tight mb-6 md:mb-0" data-id="element-243">
          DEFENDETE Megapack Ciudadano
        </h2>

        {/* Mobile: Horizontal Scroll */}
        <div className="md:hidden flex overflow-x-auto snap-x snap-mandatory gap-4 pb-3 mt-6 scrollbar-hide" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-244">
          {stats.map((stat, i) => <div key={i} className="flex-shrink-0 snap-center bg-white/10 rounded-lg px-6 py-4 min-w-[120px]" data-id="element-245">
              <strong className="block font-display text-[36px] text-gold leading-none" data-id="element-246">
                {stat.number}
              </strong>
              <span className="text-[11px] opacity-75 uppercase tracking-wider font-semibold mt-1.5 block" data-id="element-247">
                {stat.label}
              </span>
            </div>)}
        </div>

        {/* Desktop: 6-col Grid */}
        <div className="hidden md:grid grid-cols-6 gap-6 mt-9" data-id="element-248">
          {stats.map((stat, i) => <div key={i} data-id="element-249">
              <strong className="block font-display text-[42px] text-gold leading-none" data-id="element-250">
                {stat.number}
              </strong>
              <span className="text-[12px] opacity-75 uppercase tracking-wider font-semibold mt-1 block" data-id="element-251">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}